export default {
	kSession: '',
	user_data: null,
};



// WEBPACK FOOTER //
// ./src/vuex/state.js